export const environment = {
  production: false,
  env: 'qa',

  //NHSA
  /*rootDomainUrl: 'https://qa2.api.nhsa.com/',
  baseApiUrl: 'https://qa2.api.nhsa.com/api/',
  nopCommerceUrl: 'https://qa2.nhsa.com/',
  //rootDomainUrl: 'https://086f-170-82-156-136.ngrok.io/',
  //baseApiUrl: 'https://086f-170-82-156-136.ngrok.io/api/',
  // rootDomainUrl: 'https://qa1.nationalhighwaysafetyadministration.com/',
  // baseApiUrl: 'https://qa1.nationalhighwaysafetyadministration.com/api/',
  storageName: '__coursedb',
  sqliteDbName: 'course-app-sqlite.db',
  tokenName: 'course-token',
  appLogo: '../../assets/images/NHSA_logo.png',*/

  //ELDT
  /*rootDomainUrl: 'https://qa2.api.eldtdirect.com/',
  baseApiUrl: 'https://qa2.api.eldtdirect.com/api/',
  nopCommerceUrl: 'https://qa2.eldtdirect.com/',
  storageName: '__eldtdb',
  sqliteDbName: 'eldt-app-sqlite.db',
  tokenName: 'eldt-token',
  appLogo: '../../assets/images/ELDTDirect_150.png',*/

  //CDL
  /*rootDomainUrl: 'https://qa2.api.cdldirect.com/',
  baseApiUrl: 'https://qa2.api.cdldirect.com/api/',
  nopCommerceUrl: 'https://qa2.cdldirect.com/',
  storageName: '__cdldb',
  sqliteDbName: 'cdl-app-sqlite.db',
  tokenName: 'cdl-token',
  appLogo: '../../assets/images/CDLDirect_150.png',*/

  //WEB
  rootDomainUrl: 'https://qa1.api.nhsa.com/',
  baseApiUrl: 'https://qa1.api.nhsa.com/api/',
  nopCommerceUrl: '/',
  acpUrl: '/acp/',
  courseAdminUrl: '/course-admin/',
  storageName: '__webdb',
  tokenName: '',
  sqliteDbName: 'course-web-app-sqlite.db',
  appLogo: '../../assets/images/NHSA_logo.png',


  blobAssetPath: 'assets/',
  assetPath: '/assets/',
  froalaLicenseKey: null,
  timezone: 'America/New_York',
  StoreName: null,
  StoreLogo: null,
  StorePhone: null,
  StoreEmail: null,
  AssetsUrl: null,
  ActivitiesUrl: 'https://activities.nationalhighwaysafetyadministration.com/',
  AffiliateLogo: null,
  StoreId: null,
  AffiliateSchoolName: null,
  stringResources: [],
  settings: {
    AssetsUrl: null
  }
};
